export const apiURL = 'https://api.vaurioauto.fi/api/';
//export const apiURL = 'https://vapi.iltavuoro.dev/api/';
//export const apiURL = 'https://vaurioauto-api.test/api/';

export const addMissingLangStrings = true;
export const highlightMissingTranslations = true;
